module.exports = __webpack_public_path__ + "static/media/dashboard.212fe5ed.svg";